import * as types from '../types';

export default {
  [types.GET_TEAM_SELECT](state, data) {
    state.teamList = data;
  },
  [types.GET_BUSI_STAGE_LIST](state, data) {
    state.busiStageList = data.results;
  },
  [types.GET_BUSI_OPPORTUNITY_LIST](state, data) {
    state.busiOpportunityList = data;
  },
  [types.GET_CUSTOM_SELECT_DATA](state, data) {
    state.CustomSelectData = data;
  },
  [types.GET_BUSI_OPPORTUNITY_DETAIL](state, data) {
    state.busiOpportunityDetail = data;
  },
  [types.GET_BUSI_VISIT_DATA](state, data) {
    state.busiVisitData = data;
  },
  [types.GET_BUSI_SALES_DATA](state, data) {
    state.busiSalesData = data;
  },
  [types.GET_BUSI_FILE_DATA](state, data) {
    state.busiFileData = data;
  },
  [types.GET_BUSI_LINE_LIST](state, data) {
    state.busiLineList = data.results;
  },
  [types.GET_BUSI_SALES_LIST](state, data) {
    state.busiSalesList = data.data;
  },
  [types.GET_BUSI_CONTACT_LIST](state, data) {
    state.busiContacts = data.results;
  },
  [types.GET_BUSI_DETAIL_CONTACT_LIST](state, data) {
    state.detailContacts = data;
  },
};
